import React from 'react';
import { Palette, MousePointer2, Focus, Layers, PenTool, Eye } from 'lucide-react';
import './SaaSDevelopment.css';

const UIUXDesign = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Design Systems</span>
            <h1>Intuitive Designs that Delight Your Users</h1>
            <p>
              We bridge the gap between complex functionality and user-friendly 
              interfaces with data-driven UX and stunning UI design.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Start Designing</a>
              <a className="button secondary" href="#process">Our Process</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <Palette className="icon" />
              <h3>Visual Identity</h3>
              <p>Creating consistent brand languages that resonate with your target audience.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="process" className="section">
        <div className="section-heading">
          <span className="eyebrow">The Method</span>
          <h2>Design thinking at every step.</h2>
          <p>Our approach starts with understanding your users and ends with high-fidelity prototypes that define the future of your product.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><Focus size={24} /></div>
            <h3>User Research</h3>
            <p>Identifying pain points and opportunities through interviews and behavioral mapping.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Layers size={24} /></div>
            <h3>Wireframing</h3>
            <p>Constructing the structural blueprint of your application to ensure logical flow.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><MousePointer2 size={24} /></div>
            <h3>Interactive Prototyping</h3>
            <p>Experience the product before a single line of code is written.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><PenTool size={24} /></div>
            <h3>Design Systems</h3>
            <p>Building reusable component libraries for consistency and faster development.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="solutions-container">
          <div className="solution-row">
            <div className="solution-copy">
              <h3>Human-Centered UX</h3>
              <p>
                We focus on accessibility and usability to make sure your 
                application is usable by everyone, regardless of their tech literacy.
              </p>
              <ul className="feature-list">
                <li><Eye size={18} /> Accessibility Audit (WCAG)</li>
                <li><Eye size={18} /> Usability Testing</li>
                <li><Eye size={18} /> Conversion Rate Optimization</li>
              </ul>
            </div>
            <div className="solution-media">
               <div className="panel-card panel-gradient">
                <Focus size={64} className="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>40%</strong>
          <span>Higher Engagement</span>
        </div>
        <div className="metric-item">
          <strong>100%</strong>
          <span>Brand Consistency</span>
        </div>
        <div className="metric-item">
          <strong>WCAG</strong>
          <span>Compliance</span>
        </div>
        <div className="metric-item">
          <strong>Pixel</strong>
          <span>Perfect Delivery</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Need a design revamp?</h2>
          <p>Let is transform your current application into a beautiful, user-centric experience.</p>
          <a className="button primary" href="#contact">Get a Design Audit</a>
        </div>
      </section>
    </div>
  );
};

export default UIUXDesign;
